// extracted by mini-css-extract-plugin
export var $animation_name = "SupportHeader-module--$animation_name--570e5";
export var Inner = "SupportHeader-module--Inner--7d5fa";
export var Wrapper = "SupportHeader-module--Wrapper--e8ab9";
export var Wrapper___tall = "SupportHeader-module--Wrapper___tall--1db80";
export var Wrapper__overlay = "SupportHeader-module--Wrapper__overlay--8e489";